import React, {useEffect, useState} from 'react'
import Box from '@mui/material/Box'
import {reExportedColors} from '../../1elements'
import ServiceTypeAccordion from './ServiceTypeAccordion'
import ApiService from '../../../common/ApiCalls'

const sideMenuStyles = {
    borderRight: `1px solid ${reExportedColors.LIGHT_GREY}`, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    height: '100%',

    '&& .MuiAccordion-root': {
        boxShadow: 'none',
        margin: '5px'
    },
    '&& .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: 0
    }
}

const ClientServiceSideMenu = ({disabled, serviceList, selectServiceType, deleteService, setInput, selectedServiceType, setSelectedServiceTypeId}) => {
    const [serviceType, setServiceType] = useState([])

    useEffect(()=> {
        ApiService().getAllServiceTypes()
            .then((res)=>{
                setServiceType(res)
            })
            .catch((err)=>{
                console.log(err)
            })
    }, [])

    return(
        <Box sx={sideMenuStyles}>
            {
                serviceType.map((serviceType, index)=>(
                    <ServiceTypeAccordion disabled={disabled} serviceTypeName={serviceType} selectServiceType={selectServiceType}
                                          serviceList={serviceList[serviceType.service_type]} deleteService={deleteService}
                                          setInput={setInput} key={index} selectedServiceType={selectedServiceType}
                                          setSelectedServiceTypeId={setSelectedServiceTypeId}/>
                ))
            }
        </Box>
    )
}

export default ClientServiceSideMenu
